/**
 * The location of the configuration page of a single organization.
 *
 * Named-route form rather than a hand-built path: organization names are free text
 * and may contain a slash, which vue-router escapes only when it fills in the
 * :name parameter itself.
 */
export function configurationViewLocation(organization) {
    return {
        name: 'configuration-view',
        params: {id: organization.id, name: organization.name},
    }
}
